module.exports = __webpack_public_path__ + "img/sable_enduit.ad714973.jpg";